import * as React from 'react'
// Fuer die Translation
import { useI18next } from 'gatsby-plugin-react-i18next' 
import { graphql } from 'gatsby'
// Import von components
import Layout from '../../components/layout/layout'


const ImpressumPage = () => {
  const {t} = useI18next();
    return (
      <Layout pageTitle={t('title')}>
        <div className="row">
        <div className="col-1"></div>
        <div className="col-10">
          <h2 >
            {t('title1')}
          </h2>
          <p > {t('text11')}
          <br /> {t('text12')}
          <br /> {t('text13')}
          <br /> {t('text14')}
          <br /> {t('text15')}
          <br /> {t('text16')}
          <br /> {t('text17')}
          <br /> {t('text18')}          
          <br /> {t('text19')}
          </p>
          <h2 >
            {t('title2')}
          </h2>
          <p > {t('text21')}
          <br /> {t('text22')}
          <br /> {t('text23')}
          </p>
          <h2 >
            {t('title3')}
          </h2>
          <p > {t('text31')}
          </p>
          <h2 >
            {t('title4')}
          </h2>
          <p > {t('text41')}
          </p>
          
        </div>
      </div>  
    </Layout> 
    )
}
  

  
  // Step 3: Export your com ponent  v
export default ImpressumPage

export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["impressum"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;